import React, { useEffect, useState } from "react";
import api, { resolveImageUrl } from "@/lib/api";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function About() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="about-page">
      <section className="bg-white border-b border-msr-line">
        <div className="msr-container py-16 lg:py-24 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="overline mb-3">About MSR</div>
            <h1 className="font-heading font-extrabold text-4xl lg:text-6xl tracking-tight" data-testid="about-title">
              Filipino-built technology<br /> for the operations that<br /> run your business.
            </h1>
            <p className="mt-6 text-msr-slate leading-relaxed text-lg max-w-2xl" data-testid="about-long">{settings?.about_long}</p>
          </div>
          <div className="lg:col-span-5 relative">
            <div className="absolute -inset-4 border-2 border-msr-blue/20" aria-hidden />
            <div className="absolute -bottom-4 -right-4 h-16 w-16 bg-msr-green" aria-hidden />
            <img src="https://images.pexels.com/photos/36356065/pexels-photo-36356065.jpeg?auto=compress&cs=tinysrgb&w=1600" alt="MSR Office" className="relative w-full h-[400px] object-cover" />
          </div>
        </div>
      </section>

      <section className="bg-msr-surface border-b border-msr-line">
        <div className="msr-container py-16 grid md:grid-cols-3 gap-5">
          {[
            { title: "Mission", body: "Equip Filipino organizations with practical, dependable technology that scales with their operations." },
            { title: "Approach", body: "End-to-end ownership: from architecture and deployment to support and ongoing improvements." },
            { title: "Commitment", body: "Real partnerships built on transparency, communication, and shared vision for long-term outcomes." },
          ].map((m) => (
            <div key={m.title} className="msr-card border-t-4 border-t-msr-blue" data-testid={`about-pillar-${m.title.toLowerCase()}`}>
              <div className="overline mb-2">{m.title}</div>
              <p className="text-msr-slate leading-relaxed">{m.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white">
        <div className="msr-container py-16 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="overline mb-3">What we cover</div>
            <h2 className="font-heading font-extrabold text-3xl lg:text-4xl tracking-tight mb-6">An accountable partner for the full stack of business technology.</h2>
            <ul className="grid sm:grid-cols-2 gap-3">
              {[
                "Ready-made software platforms",
                "Custom system development",
                "Enterprise hardware supply",
                "IT infrastructure deployment",
                "Network & cabling services",
                "Cloud & on-premise hosting",
                "Maintenance & SLA support",
                "Training & documentation",
              ].map((t) => (
                <li key={t} className="flex items-start gap-2 text-sm">
                  <CheckCircle2 size={16} className="text-msr-green mt-0.5 flex-shrink-0" /> {t}
                </li>
              ))}
            </ul>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/solutions" className="btn-msr-primary">Browse solutions</Link>
              <Link to="/contact" className="btn-msr-outline">Talk to MSR</Link>
            </div>
          </div>
          <div className="lg:col-span-5">
            <img src="https://images.pexels.com/photos/8867431/pexels-photo-8867431.jpeg?auto=compress&cs=tinysrgb&w=1280" alt="MSR Team" className="w-full h-[420px] object-cover" />
          </div>
        </div>
      </section>
    </div>
  );
}
